export default "__VITE_ASSET__71b43663__"